// extracted by mini-css-extract-plugin
module.exports = {"shimmer":"styles-styles__shimmer--1GMN0"};